export const getList = (state) => state.list;
export const getApiStatus = (state) => state.apiStatus;
export const getSelections = (state) => state.selections;
export const areAllSelected = (state) => state.selectAll;
